import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/outlet/pos')({
	component: RouteComponent,
})

function RouteComponent() {
	return <Outlet />
}
